import { render, staticRenderFns } from "./AppDataPagination.vue?vue&type=template&id=80ac5f6c&"
import script from "./AppDataPagination.vue?vue&type=script&lang=js&"
export * from "./AppDataPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports